import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class LoginService {
 
  constructor(private http: HttpClient) {}
  postLogin(formData: any): Observable<any> {
    // const data = JSON.stringify(formData.value);
    const data = {
      username: formData.login,
      password: formData.pass,
      type:"USER"
    };
    
    return this.http.post(environment.serverUrl + 'login', data);
  }
  postLoginSocial(formData: any): Observable<any> {
    // const data = JSON.stringify(formData.value);
    return this.http.post(environment.socialLoginUrl + 'api/auth/socialLogin', formData);
  }
  restoCheck(id):Observable<any>{
  
    return this.http.get(environment.baseUrl + 'restaurantId=' +id );
    
  }

  restoCheckTable(id,tableid):Observable<any>{
return this.http.get(environment.baseUrl +'restaurantId=' + id +'&table_id=' + tableid)
  }

  restaurantAll():Observable<any>{
    return this.http.get(environment.baseUrl +'restaurantAll')
  }
  
  register(formData: any): Observable<any> {
    const data = {
      name: formData.name,
      email: formData.email,
      mobile:formData.mobile,
      password: formData.pass
    };
    return this.http.post(environment.serverUrl + 'register', data);
  }
  
  
  trackVisitor(id :any): Observable<any> {
    const data ={
      restaurant_id:id
    }; 
   return this.http.post(environment.visitorUrl ,data);
  }

}
